import React, { useEffect, useState } from 'react';
import { Check } from 'lucide-react';
import { StepIntro, TextAreaField } from '../fields';
import { wget } from '../api';

export default function StepServices({ data, set }) {
  const [cats, setCats] = useState([]);
  useEffect(() => { wget('/website/config').then((c) => setCats(c.services || [])).catch(() => {}); }, []);
  const selected = data.selected || [];
  const toggle = (s) => set({ ...data, selected: selected.includes(s) ? selected.filter((x) => x !== s) : [...selected, s] });
  return (
    <div className="space-y-5">
      <StepIntro title="Your services" text="Tick everything you offer — each one gets its own section on the website." />
      {cats.map((c) => (
        <div key={c.key} data-testid={`ww-services-${c.key}`}>
          <h3 className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-2">{c.label}</h3>
          <div className="grid sm:grid-cols-2 gap-2">
            {c.items.map((s) => {
              const on = selected.includes(s);
              return (
                <button key={s} type="button" onClick={() => toggle(s)} aria-pressed={on} data-testid={`ww-service-${s.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
                  className={`flex items-center gap-2 rounded-lg border px-3 py-2.5 text-left text-sm transition-colors ${on ? 'bg-teal-600 border-teal-600 text-white' : 'bg-white border-slate-300 text-slate-800 hover:border-slate-500'}`}>
                  <span className={`w-5 h-5 rounded-md border flex items-center justify-center shrink-0 ${on ? 'bg-white/20 border-white/40' : 'border-slate-300'}`}>{on && <Check className="w-3.5 h-3.5" />}</span>
                  <span className="leading-tight">{s}</span>
                </button>
              );
            })}
          </div>
        </div>
      ))}
      <TextAreaField id="other_services" label="Other services" value={data.other} onChange={(v) => set({ ...data, other: v })} optional rows={3} placeholder="Anything else you offer — one per line" />
      <p className="text-xs text-slate-500" data-testid="ww-services-count">{selected.length} selected</p>
    </div>
  );
}
